import { useNavigate } from 'react-router-dom'
import { Table, Input } from 'reactstrap'
import { enterKeyHandler } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import CustomSelectListInput from '../CustomSelectListInput'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import DateRangeInput from '../DateRangeInput'
import FormHeading from '../FormHeading'
import FormSubmitButton from '../FormSubmitButton'
import TextInput from '../TextInput'

export default function QuarterlyAuditReportForm({ location }) {
  console.log('QuarterlyAuditReportForm rendered: ', location)

  let init = {
    plaintiffLastName: '',
    settlementGroup: [],
    filingFrom: '',
    filingTo: '',
    caseStatus: [],
    source: [],
    hasSettlementAmount: '',
    hasProducts: '',
    isMultiManufacturer: '',
    outputToCSV: 'N'
  }

  const params = new URLSearchParams(location.search)
  const oldInputs = JSON.parse(params.get('oldInputs'))
  if (oldInputs) {
    for (let input in oldInputs) {
      init[input] = oldInputs[input]
    }
    init.outputToCSV = 'Y'
  }

  const navigate = useNavigate()
  init = initialFormValues('QuarterlyAuditReportForm', navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))

  async function submitSearch() {
    submitFormValues('QuarterlyAuditReportForm', navigate, inputs, 'quarterly_audit_new.report')
  }

  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{ backgroundColor: 'white' }}>
            <FormHeading headingText='Quarterly Audit Report' />
            <tbody>
              <TextInput label='Plaintiff Last Name' name='plaintiffLastName' handleInputChange={handleInputChange} defaultValue={inputs.plaintiffLastName} />
              <CustomSelectListInput label="Settlement Group" handleChange={handleInputChange} modelName="BosSci" entityName="settlement_group" name='settlementGroup' multiple={true} defaultValue={inputs.settlementGroup} />
              <DateRangeInput label='Date Assigned' name='filing' handleInputChange={handleInputChange} defaultValueFrom={inputs.filingFrom} defaultValueTo={inputs.filingTo} />
              <CustomSelectListInput label="Case Status" handleChange={handleInputChange} modelName="BosSci" entityName="claim_status" name='caseStatus' multiple={true} defaultValue={inputs.caseStatus} />
              <CustomSelectListInput label="Source" handleChange={handleInputChange} modelName="BosSci" entityName="source" name='source' multiple={true} defaultValue={inputs.source} />
              <tr>
                <td><b>Has Settlement Amount?</b></td>
                <td> <Input
                  type="select"
                  bsSize="sm"
                  name="hasSettlementAmount"
                  onChange={handleInputChange}
                  defaultValue={inputs.hasSettlementAmount}
                >
                  <option value={''}></option>
                  <option value={'Y'}>Yes</option>
                  <option value={'N'}>No</option>
                </Input></td>
              </tr>
              <tr>
                <td><b>Has Products?</b></td>
                <td> <Input
                  type="select"
                  bsSize="sm"
                  name="hasProducts"
                  onChange={handleInputChange}
                  defaultValue={inputs.hasProducts}
                >
                  <option value={''}></option>
                  <option value={'Y'}>Yes</option>
                  <option value={'N'}>No</option>
                </Input></td>
              </tr>
              <tr>
                <td><b>Is Multi-manufacturer?</b></td>
                <td> <Input
                  type="select"
                  bsSize="sm"
                  name="isMultiManufacturer"
                  onChange={handleInputChange}
                  defaultValue={inputs.isMultiManufacturer}
                >
                  <option value={''}></option>
                  <option value={'Y'}>Yes</option>
                  <option value={'N'}>No</option>
                </Input></td>
              </tr>
              <tr>
                <td><b>Output to CSV?</b></td>
                <td> <Input
                  type="select"
                  bsSize="sm"
                  name="outputToCSV"
                  defaultValue={inputs.outputToCSV}
                  onChange={handleInputChange}
                >
                  <option value={''}></option>
                  <option value={'Y'}>Yes</option>
                  <option value={'N'}>No</option>
                </Input></td>
              </tr>
            </tbody>
          </Table>
        </div>
        <FormSubmitButton />
      </form>
    </div>
  )
}

